<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br />
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <form>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-2">
                <label for="fromDate">From Date</label>
                <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled" />
                <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate" />
              </div>
  
              <div class="p-field p-col-12 p-md-2">
                <label for="toDate">To Date</label>
                <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled" />
                <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate" />
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button @click.prevent="searchUnpaidInvoice" class="p-button-raised" label="Search"
                  icon="pi pi-search" />
              </div>
            </div>
          </form>

        <DataTable :value="salesUnreceivedList" ref="po" :paginator="true" :rows="100" 
                  :rowsPerPageOptions="[100, 500, 1000]" :filters="filters" editMode="cell"
                  class="p-datatable-responsive p-datatable-gridlines" data-key="id"
                  :selection.sync="selectedProduct1" selectionMode="single">
          <template #header>
            <div style="text-align: left">
              <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
            </div>
          </template>
          
          <Column header="S.N">
            <template #body="sl">
              {{ sl.index + 1 }}
            </template>
          </Column>
          
          <Column header="Miti" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDateNepali"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDateNepali']" />
            </template>
          </Column>
          
          <Column header="Date" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDate"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDate']" />
            </template>
          </Column>
          
          <Column header="Bill No" :sortable="true" field="billNo" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['billNo']" />
            </template>
          </Column>
          
          <Column header="Customer" :sortable="true" field="accountName" filterMatchMode="contains">
            <template #body="slotProps">
              {{ slotProps.data.accountMaster.name }}
            </template>
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['accountName']" />
            </template>
            <template #footer>
              Total:
            </template>
          </Column>
          
          <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['address']" />
            </template>
          </Column>
          
          <Column header="Contact No" :sortable="true" field="contactNumber" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
            </template>
          </Column>

          <Column header="Remarks"  >
            <template #body="slotProps">
            <Button class="p-button-raised p-button-warning" v-tooltip.top="'View Remarks'"
                      @click="showMessageDialog(slotProps.data)" ><span class="pi pi-envelope"></span></Button>
            </template>
            </Column>
            <Column header="Transportation Details"  >
                <template #body="slotProps">
                    
            <Button  class="p-button-raised p-button-warning" v-tooltip.top="'View Transport Details'"
                      @click="showTransportationDialog(slotProps.data)" ><span class="fa fa-truck"></span></Button>
            </template>
            </Column>
          
            <Column header="Sold By" :sortable="true" field="soldBy" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['soldBy']"/>
                </template>
              </Column>
      
          <Column header="Total" bodyStyle="text-align: right" field="totalBillAmount" :sortable="true"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['totalBillAmount']" />
            </template>
            <template #footer>
              {{ totalSumBillAmount.toFixed(2) }}
            </template>
          </Column>
          
          <Column header="Received Status" bodyStyle="text-align: right" field="goodsReceivedStatus" :sortable="true"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['goodsReceivedStatus']"/>
            </template>
            <template #editor="slotProps">
              <Dropdown v-model="slotProps.data['goodsReceivedStatus']" :options="statusesPay"
                        @change="updatePaymentStatus(slotProps.data, 'drop')"
                        optionLabel="label" optionValue="value" placeholder="Select a Status">
                <template #option="slotProps">
                  <span>{{ slotProps.option.label }}</span>
                </template>
              </Dropdown>
            </template>
            <template #body="slotProps">
              {{ getReceivedStatusLabel(slotProps.data.goodsReceivedStatus) }}
            </template>
          </Column>
          
          <Column header="Org Name" :sortable="true" field="organisationName" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['organisationName']"/>
            </template>
          </Column>
          
          <Column header="Action">
            <template #body="slotProps">
              <Button class="p-button-raised p-button-warning" v-tooltip.top="'View Details'"
                      @click="viewPIVDetail(slotProps.data)">
                <span class="fa fa-eye"></span>
              </Button>
            </template>
          </Column>
          
          <template #empty>No record found</template>
        </DataTable>
      </div>
      
      <Dialogs header="Remarks" :visible.sync="receivedMessageDialog"
                 :style="{width: '50vw'}" :modal="true" :closable=true :contentStyle="{'overflow': 'visible'}">
          <div class="col-md-12">
            <label for="reason" class="col-md-4 control-label">Remarks</label>
            <div class="form-group col-md-8">
              <textarea class="form-control" rows="5" v-model="receivedMessgae"></textarea>
            </div>
          </div>
          <template #footer>
            <Button class="p-button-raised p-button-success" @click.prevent="updatePaymentStatus(null, 'ramarks')"
                    label="Update"/>
            <Button class="p-button-raised p-button-danger" @click="cancelMessage" label="Cancel"/>
          </template>
        </Dialogs>
      
      <Dialogs header="Transportation Details" :visible.sync="transportationDialog"
             :style="{width: '50vw'}" :modal="true" :closable=true :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-4">
            <label for="subHead">Name<span style="color:red"></span></label>
            <InputText v-model.trim="transportationDetails.name" id="subHead"/>
          </div>
          
          <div class="p-field p-col-12 p-md-4">
            <label for="costing">Route</label>
            <InputText v-model.trim="transportationDetails.route" id="subHead"/>
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label for="costing">Address</label>
            <InputText v-model.trim="transportationDetails.address" id="subHead"/>
          </div>
          
          <div class="p-field p-col-12 p-md-4">
            <label for="vat">Contact Name</label>
            <InputText v-model.trim="transportationDetails.contactPerson" id="subHead"/>
          </div>
          
          <div class="p-field p-col-12 p-md-4">
            <label for="head">From Contact Number <span style="color:red"></span></label>
            <InputText v-model.trim="transportationDetails.contactNumberFrom" id="subHead"/>
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label for="head">To Contact Number</label>
            <textarea type="text" rows="2" class="form-control" v-model="transportationDetails.contactNumberTo"/>
          </div>
        </div>
        <template #footer>
          <Button class="p-button-raised p-button-danger" @click.prevent="closelTransportation" label="Close"/>
        </template>
      </Dialogs>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport" />
  </section>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import InputMask from 'primevue/inputmask'
import Dropdown from 'primevue/dropdown'
import Dialogs from 'primevue/dialog'
import $ from 'jquery'
export default {
  name: 'SalesInvoiceUnpaidWithDateRange',
  props: ['status'],
  data() {
    return {
      id: null,
      fromDate: null,
      toDate: null,
      transportationDetails: {
        name: '',
        route: '',
        address: '',
        contactPerson: '',
        contactNumberFrom: '',
        contactNumberTo: ''
      },
      loading: false,
      receivedMessgae: '',
      dialogShow: false,
      transportationDialog: false,
      receivedMessageDialog: false,
      selectedProduct1: null,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      enableEdit: false,
      enableDelete: false,
      totalSumBillAmount: 0,
      goodsReceivedStatus: '',
      statusesPay: [
        {label: 'Processing', value: 'Processing'},
        {label: 'Completed', value: 'Completed'},
        {label: 'OnTheWay', value: 'OnTheWay'}
      ]
    }
  },
  computed: {
    salesUnreceivedList() {
      return this.$store.state.sales.salesUnreceivedAllLists
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async searchUnpaidInvoice() {
      this.loading = true
      try {
        const data = {
          fromDate: this.fromDate,
          toDate: this.toDate
        }
        const resp = await this.$store.dispatch('loadSalesInvoiceUnReceivedAllLists', data)
        if (resp.data.data.length <= 0) {
          this.$toast.add({ severity: 'error', summary: '', detail: resp.data.message, life: 3000 })
        } else {
          this.salesUnreceivedList = resp.data.data
          this.totalBalance()
        //  this.$toast.add({ severity: 'success', summary: '', detail: resp.data.message, life: 3000 })
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load data',
          life: 3000
        })
      } finally {
        this.loading = false
      }
    },
    async viewPIVDetail(data) {
      let PIHdata = {
        id: data.id,
        warehouse: data.warehouse,
        account: data.accountMaster,
        salesDate: data.purchaseSalesDateNepali,
        billNo: data.billNo,
        reportType: data.reportType,
        referenceNumber: data.referenceNumber,
        subTotalAmount: data.subTotalAmount,
        nonTaxableAmount: data.nonTaxableAmount,
        taxableAmount: data.taxableAmount,
        vatAmount: data.vatAmount,
        totalBillAmount: data.totalBillAmount,
        vatTypeEnum: data.vatTypeEnum,
        exciseChargeAmount: data.exciseChargeAmount,
        discountAmt: data.discount,
        remarks: data.remarks
      }
      if (data.purchaseType !== 'dairy') {
        this.$router.push({ name: 'sales Detail Report', params: { salesHeaderObj: PIHdata } })
      } else {
        this.$router.push({ name: 'sales Detail Dairy Report', params: { purchaseHeaderObj: PIHdata } })
      }
    },
    exportCSV() {
      this.$refs.po.exportCSV()
    },
    async updatePaymentStatus(data, type) {
      if (type === 'drop') {
        this.goodsReceivedStatus = data.goodsReceivedStatus
        this.id = data.id
        this.receivedMessgae = data.receivedRemarks
      }
      if (this.receivedMessgae === undefined) {
        this.receivedMessgae = '-'
      }
      let payment = {
        id: this.id,
        goodsReceivedStatus: this.goodsReceivedStatus,
        receivedRemarks: this.receivedMessgae
          // status: data.paymentStatus,
          // method: data.paymentMethod
      }
      let response = await this.$store.dispatch('goodsReceivedStatusUpdate', payment)
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({
          severity: 'success',
          summary: '',
          detail: response.data.message,
          life: 3000
        })
      }
      this.receivedMessageDialog = false
    },
    getReceivedStatusLabel(payStatus) {
      switch (payStatus) {
        case 'Processing': return 'Processing'
        case 'Completed': return 'Completed'
        case 'OnTheWay': return 'OnTheWay'
        default: return 'NA'
      }
    },
    showMessageDialog(data) {
      this.receivedMessgae = data.receivedRemarks
      this.goodsReceivedStatus = data.goodsReceivedStatus
      this.id = data.id
      this.receivedMessageDialog = true
    },
    showTransportationDialog(data) {
      this.transportationDetails = data.transportation || {
        name: '',
        route: '',
        address: '',
        contactPerson: '',
        contactNumberFrom: '',
        contactNumberTo: ''
      }
      this.transportationDialog = true
    },
    cancelMessage() {
      this.receivedMessageDialog = false
      this.receivedMessgae = ''
    },
    closelTransportation() {
      this.transportationDialog = false
    },
    totalBalance() {
      this.totalSumBillAmount = this.salesUnreceivedList.reduce(
        (sum, item) => sum + (item.totalBillAmount || 0),
        0
      )
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    },
    cancel() {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    Button,
    InputMask,
    Dropdown,
    Dialogs
  }
}
</script>

<style scoped src="@../../../static/css/purchase.css"></style>



// WEBPACK FOOTER //
// salesInvoiceUnreceivedAllReport.vue?afc37c88